export { default as PbOutputViewer } from './component';
